import React, { useEffect, useMemo, useState } from 'react';
import { Button, CloseButton, FormControl } from 'react-bootstrap';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import AppPage from '../common/AppPage';
import { queryMobs, setQuery } from './mobsSlice';
import DataTable from 'react-data-table-component';
import { styles, getColumns } from './tableConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';

let debounceId: any;

function MobsPage() {
  const dispatch = useAppDispatch();
  const query = useAppSelector(state => state.mobs.query);
  const mobs = useAppSelector(state => state.mobs.mobs);
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  
  useEffect(() => {
    dispatch(queryMobs());
  }, [dispatch]);

  const handleRefresh = () => {
    clearTimeout(debounceId);
    dispatch(queryMobs());
  }

  const handleQueryChange = (value: string) => {
    dispatch(setQuery(value));
    clearTimeout(debounceId);
    debounceId = setTimeout(() => setDebouncedQuery(value), 300);
  }

  const handleClearClick = () => {
    dispatch(setQuery(''));
    clearTimeout(debounceId);
    setDebouncedQuery('');
  }
  
  const filteredColumns = useMemo(() => {
    return getColumns(debouncedQuery);
  }, [debouncedQuery]);

  const filteredData: any[] = useMemo(() => {
    let data = mobs;
    if (debouncedQuery) {
      const lowerQuery = debouncedQuery.toLowerCase();
      data = data.filter((row: any) => {      
        return filteredColumns.some(x => {
          return x.selector?.(row)?.toString()?.toLowerCase()?.includes(lowerQuery);
        })
      });  
    }    
    return data;
  }, [filteredColumns, mobs, debouncedQuery]);

  return (
    <AppPage pageClass="mobs-page">
      <div className="mobs">
        <h5>WoTMud Mob Loads</h5>
        <div className="row g-0 gx-2 gy-0 mb-3">
          <div className="col-12 col-md-6 col-lg-4 mb-2">
            <label className="xsmall mb-0">SEARCH</label>
            <div className="position-relative">
              <FormControl
                value={query}
                onChange={e => handleQueryChange(e.target.value)}
                size="sm" style={{paddingRight: '1.75rem'}}/>
              {query &&
                <CloseButton style={{position: 'absolute', right: '.375rem', top: '7px', fontSize: '.75rem', lineHeight: 1}} onClick={() => handleClearClick()}/>
              }
            </div>
          </div>
          <div className="col-auto mb-2">
            <label className="xsmall mb-0">&nbsp;</label>
            <Button size="sm" onClick={() => handleRefresh()}><FontAwesomeIcon icon={faArrowsRotate} /></Button>
          </div>
        </div>
      </div>
      
      <DataTable
        theme="custom"
        columns={filteredColumns}
        data={filteredData}        
        striped={true}
        customStyles={styles}
        defaultSortFieldId={'name'}
      />
    </AppPage>
  );
}

export default MobsPage;